import { useEffect, useRef } from 'react';

import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';

export const useInputFieldFocus = () => {
  const inputFieldRef = useRef<HTMLInputElement>(null);

  const { chatId } = useParentHelperContext();

  useEffect(() => {
    if (inputFieldRef.current) {
      inputFieldRef.current.focus();
    }
  }, [chatId]);

  return { inputFieldRef };
};
